import { QuestionBase } from "./question-base.model";

export class BarcodeQuestion extends QuestionBase<string> { 
    controlType = 'barcode';
    value: any;    
    
    constructor(options: {} = {}) {
        super(options);        
        this.value = options['value'] || 'No Values';
        this.key = options['key'];
        this.label = options['label'];
    }
}